import { WIKO_ERROR__MALFORMED_BIGINT_STRING, WikoError } from '@wiko/errors';

export type StringifiedBigInt = string & { readonly __brand: unique symbol };

export function isStringifiedBigInt(putativeBigInt: string): putativeBigInt is StringifiedBigInt {
    try {
        BigInt(putativeBigInt);
        return true;
    } catch {
        return false;
    }
}

export function assertIsStringifiedBigInt(putativeBigInt: string): asserts putativeBigInt is StringifiedBigInt {
    try {
        BigInt(putativeBigInt);
    } catch {
        throw new WikoError(WIKO_ERROR__MALFORMED_BIGINT_STRING, {
            value: putativeBigInt,
        });
    }
}

export function stringifiedBigInt(putativeBigInt: string): StringifiedBigInt {
    assertIsStringifiedBigInt(putativeBigInt);
    return putativeBigInt;
}
